export const POSITION = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};
